import { compose } from 'ramda'
import BookingProduct from '@v/bookings/edit/models/BookingProduct.js'
import { Success, Failure, chain } from 'folktale/validation'
import { splitAndValidateId, validateProps, joinProduct } from './mapUtils.js'
import { makeBookingProduct } from './makeBookingProduct.js'

export const mapJsonParamToBookingProduct = (products, jsonParam) =>
  sequence(parseAndValidate, handleId(products), addProductFields)(jsonParam)

// a helper that can be used to write monadic comprehensions (sort of)
const sequence = (...args) => args.reduce((acc, n) => x => chain(acc(x), n))

const parseAndValidate = compose(validateParsedObject, JSON.parse)

// The parsed object must either only contain id (this is the case for create booking) or a number of props for bookingproducts that belong to a deal
export function validateParsedObject(bookingProduct) {
  return Object.entries(bookingProduct).length === 1
    ? validateProps(['id'])(bookingProduct)
    : validateDealBookingProduct(bookingProduct)
}

const validateDealBookingProduct = validateProps([
  'id',
  'productKey', // The product this bookingproduct belongs to
  'productGroupKey', // The deal this bookingproduct belongs to
  'productGroupName',
  'productGroupProductKey', // The junction between product and deal, API needs this, eg. for a modified product price within the deal
  'dealId',
])

const handleId = products => parsed =>
  splitAndValidateId(parsed.id)
    .map(value => ({
      ...parsed,
      resourceKey: value.resourceKey,
      fromDateTimeUTC: value.fromDateTimeUTC,
    }))
    .map(joinProduct(products))

const addProductFields = value =>
  value.product
    ? Success(makeBookingProduct(value))
    : Failure([
        `Could not find product with key ${value.productKey} or resource key: ${value.resourceKey}`,
      ])
